import { SET_LOGIN_USER_IMAGE } from "./constant";

export function setUserImage(data) {
  return {
    type: SET_LOGIN_USER_IMAGE,
    payload: data
  }
}